import React from 'react'
import './App.css';
import googleplayBadge from './google-play-badge.png';
import steamBadge from './steam-badge.png';

const App = () => {
  return (
    <section class='container'>
      <header>
        <left>
          <svg id="Bg_Top_Left" height="100%" width="100%" viewBox="0 0 200 200" preserveAspectRatio="none"
            shape-rendering="geometricPrecision">
            <polygon fill="#E21E25" points="-3.302,-0.545 -3.302,203.333 200.576,-0.545 " />
          </svg>
        </left>
        <right>
          <svg id="Bg_Top_Right" height="100%" width="100%" viewBox="0 0 200 200" preserveAspectRatio="none"
            shape-rendering="geometricPrecision">
            <polygon fill="#0768B1" points="203.777,-5.245 203.777,203.775 -5.168,-5.245 " />
          </svg>
        </right>
      </header>
      <content>
        <div></div>
        <div></div>
        <div>
          <a href="/#" class="play_button">Play Strataka</a>&nbsp;&nbsp;
          <a href="/#" class="buy_button">Buy Strataka</a>
        </div>
        <div>
          <a href="/#"><img src={googleplayBadge} width="150" alt="Google Play" /></a>&nbsp;&nbsp;
          <a href="/#"><img src={steamBadge} width="150" alt="Steam" /></a>
        </div>
        <div>
          <a href="https://x.com/playstrataka" style={{color: 'white', fontSize: 'small'}} target="_blank" rel="noreferrer">X
            (Twitter)</a>&nbsp;|&nbsp;
          <a href="https://instagram.com/playstrataka" style={{color: 'white', fontSize: 'small'}}
            target="_blank" rel="noreferrer">Instagram</a>&nbsp;|&nbsp;
          <a href="https://youtube.com/@strataka" style={{color: 'white', fontSize: 'small'}}
            target="_blank" rel="noreferrer">Youtube</a>&nbsp;|&nbsp;
          <a href="https://howtoplay.strataka.com/strataka" style={{color: 'white', fontSize: 'small'}}
            target="_blank" rel="noreferrer">How to Play</a>
        </div>
      </content>
      <footer>
        <left>
          <svg id="Bg_Bottom_Left" height="100%" width="100%" viewBox="0 0 200 200" preserveAspectRatio="none"
            shape-rendering="geometricPrecision">
            <polygon fill="#39A648" points="-3.302,203.333 200.576,203.333 -3.302,-0.545 " />
          </svg>
        </left>
        <right>
          <svg id="Bg_Bottom_Right" height="100%" width="100%" viewBox="0 0 200 200" preserveAspectRatio="none"
            shape-rendering="geometricPrecision">
            <polygon fill="#FDDA00" points="203.814,203.737 -5.206,203.738 203.814,-5.208 " />
          </svg>
        </right>
      </footer>
    </section>
  )
}

export default App